import CustomAlertManager from './CustomAlertManager';
import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';

function Home() {

    const { isAuthenticated, loginWithPopup } = useAuth0();

    useEffect(() => {
        const Login = async () => {
            if (!isAuthenticated) {
                await loginWithPopup();
            }
        };

        Login();
    }, [isAuthenticated, loginWithPopup]);

    if (!isAuthenticated) {
        return null;
    }

    return (
        <CustomAlertManager />
    );
} export default Home;
